export function hasSupporterId<T extends { supporterId: string | null }>(
  sessionSupporter: T
): sessionSupporter is T & { supporterId: string } {
  return sessionSupporter.supporterId !== null
}
